import { jsx as _jsx } from "react/jsx-runtime";
import { IDENTIFIER_ICON } from 'src/ui/components/Icons/constants';
import { ICONS } from 'src/ui/components/Icons/collection';
import { valueExist } from 'src/shared/helpers/objHelpers';
import classNames from 'classnames';
import styles from './Icons.module.scss';
export var Icons = function (props) {
    var _a;
    var icon = props.icon, color = props.color, className = props.className, disabled = props.disabled, onClick = props.onClick;
    if (!valueExist(icon)) {
        return null;
    }
    var Icon = ICONS[icon];
    return (_jsx(Icon, { "data-test": IDENTIFIER_ICON, color: color, className: classNames(styles.icon, (_a = {}, _a[styles.clickableIcon] = !!onClick, _a[styles.disabledIcon] = !!disabled, _a), className), onClick: onClick }));
};
